module.exports = __webpack_public_path__ + "img/in-scurta-adunare-a-numelor-1789-pagina-5-big.01954d03.jpg";